function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Footer-1024",
  transform: "translate(-770.000000, -221.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(758.000000, 49.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Facebook",
  transform: "translate(0.000000, 163.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons8-facebook-f",
  transform: "translate(0.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.6241856,12.4999934 L16.2419596,12.4999934 L16.2419596,11.4999953 C16.2419596,10.9839963 16.2902771,10.6589969 17.1410105,10.6589969 L17.6402915,10.6589969 C17.9578066,10.6589969 18.2155,10.4349973 18.2155,10.1589978 L18.2155,9.531999 C18.2155,9.27049949 17.9848414,9.04699991 17.6845825,9.02949994 C17.3371566,9.00899998 16.9891555,8.9995 16.6405791,8.99998127 C15.0800384,8.99998127 13.9411255,9.82849845 13.9411255,11.3494956 L13.9411255,12.4999934 L12.7907085,12.4999934 C12.4731934,12.4999934 12.2155,12.723993 12.2155,12.9999925 L12.2155,13.9999813 C12.2155,14.2759901 12.4731934,14.4999813 12.7907085,14.4999813 L13.9411255,14.4994897 L13.9411255,18.4999813 C13.9411255,18.7759817 14.198819,18.9999813 14.5163341,18.9999813 L15.6667511,18.9999813 C15.9842662,18.9999813 16.2419596,18.7759817 16.2419596,18.4999813 L16.2419596,14.4984897 L17.4924629,14.4979897 C17.7846688,14.4979897 18.0302829,14.3074901 18.063645,14.0549905 L18.1953677,13.0569924 C18.2350571,12.760493 17.9681603,12.4999934 17.6241856,12.4999934 Z",
  id: "Path",
  fillRule: "nonzero"
})))));

const SvgFacebook = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.7bcb5001.svg";
export { ForwardRef as ReactComponent };